<template>
  <div>
    <div>Tiến hành gọi điện tư vấn, xác nhận nhu cầu và thông tin cần thiết.</div>
    <div class="field-label step2-handle-file-contract mt-4 m-10 p-4 rounded" style="border: #5E00B6 solid 2px; box-shadow: 0px 12px 11px rgba(0, 0, 0, 0.25);">
      <div class="row">
        <div class="col-12 col-md-6 mb-3 w-100">
          <label class="mb-1">Kết quả xử lý <span class="text-danger">*</span></label>
          <el-select class="w-100" v-model="formStep2.result" placeholder="Chọn kết quả xử lý">
            <el-option
                v-for="item in resultHandle"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </div>

        <div class="col-12 col-md-6 mb-3" v-if="formStep2.result == 'answered'">
          <label class="mb-1">Phí trả góp <span class="text-danger">*</span></label>
          <el-input
              placeholder="Nhập phí trả góp"
              clearable
              :value="formatVND(formStep2.amount)"
              @input="onAmountInput"
          />
        </div>

        <div class="col-12 col-md-6 mb-3" v-if="['no_answer', 'callback'].includes(formStep2.result)">
          <label class="mb-1">Thời gian gọi lại <span class="text-danger">*</span></label>
          <el-date-picker
              v-model="formStep2.time_callback"
              type="datetime"
              class="w-100"
              placeholder="Chọn thời gian gọi lại"
              :picker-options="pickerOptionsCallback">
          </el-date-picker>
        </div>
      </div>

      <div class="mt-4">
        <label>Ghi chú cuộc gọi <span class="text-danger"> *</span></label>
        <ckeditor :editor="editor" v-model="formStep2.note"></ckeditor>
      </div>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <el-button style="background-color: #CACACA" @click="clear()" size="mini" class="rounded">Hủy</el-button>
        <el-button
            style="background-color: #5D04B0"
            @click="saveStep2"
            class="text-white rounded"
            size="mini"
            :disabled="!canSaveStep2 || loadingStep2"
          >
          <i :class="loadingStep2 ? 'el-icon-loading' : ''"></i>
          Lưu kết quả
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomEditor from "@/core/plugins/ckeditor5/custom-editor";
import {SAVE_RESULT_CALL_TVV, GET_RESULT_HANDLE} from "../../../../core/services/store/customer/customer-crm.module";
import moment from "moment-timezone";

export default {
  name: "step2HandleFileContract",
  components: {
    result: '',
  },
  data() {
    return {
      editor: CustomEditor,
      formStep2: {
        result: '',
        amount: '',
        note: '',
        time_callback: '',
      },
      pickerOptionsCallback: {
        disabledDate(time) {
          return time.getTime() < new Date().setHours(0, 0, 0, 0);
        }
      },
      loadingStep2: false,
      resultHandle: []
    }
  },

  computed: {
    canSaveStep2() {
      const HasTimeCallBack = ['no_answer', 'callback'].includes(this.formStep2.result) ? !!this.formStep2.time_callback : true;
      const hasResult = !!this.formStep2.result;
      const hasAmount =
          this.formStep2.result !== 'answered' ||
          (this.formStep2.amount !== '' && this.formStep2.amount >= 0 && (this.formStep2.amount === 0 || this.formStep2.amount >= 2000));
      return hasResult && hasAmount && HasTimeCallBack;
    }
  },

  mounted() {
      this.getResulHandle();
  },

  methods: {
    saveStep2() {
      this.loadingStep2 = true;
      if (!this.canSaveStep2) {
        this.$notify({
          title: 'Thiếu dữ liệu!',
          message: 'Vui lòng nhập đủ thông tin!',
          type: 'warning'
        });
        return;
      }

      const payload = {
        id: this.$route.params.id,
        result: this.formStep2.result,
        note: this.formStep2.note
      };

      if(this.formStep2.result === 'answered') {
        payload.installment_fee = this.formStep2.amount;
      }

      if(['no_answer', 'callback'].includes(this.formStep2.result)){
        payload.callback_at = moment(this.formStep2.time_callback).format('YYYY-MM-DD HH:mm:ss');
      }

      this.$store.dispatch(SAVE_RESULT_CALL_TVV, payload)
          .then((res) => {
            if (!res.error) {
              this.$notify({
                title: 'Thành công!',
                message: res.message ? res.message : 'Lưu kết quả gọi điện tư vấn thành công!',
                type: 'success'
              });
              this.formStep2.result === 'answered' ? !this.formStep2.amount ? this.$emit('next-step-4') : this.$emit('next-step-3') : this.$emit('get-log');
              this.loadingStep2 = false;
              this.clear();
            }
          })
          .catch((e) => {
            this.$notify({
              title: 'Thất bại!',
              message: e?.data?.message || 'Lưu kết quả gọi điện tư vấn thất bại!',
              type: 'error'
            });
            this.loadingStep2 = false;
          })
          .finally(() => {});
    },

    formatVND(val) {
      if (val === null || val === undefined || val === '') return '';
      const raw = String(val).replace(/\D/g, '');
      if (raw === '') return '';

      const n = Number(raw);
      return n.toLocaleString('vi-VN');
    },

    onAmountInput(value) {
      const raw = String(value || '').replace(/\D/g, '');
      this.formStep2.amount = raw === '' ? '' : Number(raw);
    },

    getResulHandle() {
      this.$store.dispatch(GET_RESULT_HANDLE, {})
          .then((res) => {
            this.resultHandle = res.data
          })
          .catch((error) => {

          });
    },

    clear() {
      this.formStep2 = {
        result: '',
        amount: '',
        note: '',
      };
    },
  }
}
</script>

<style scoped>
.step2-handle-file-contract {
  text-align: left;
}

.field-label {
  margin-top: 10px;
  text-align: left;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>


